import React, { ReactNode } from 'react';
import styles from './PlanHero.module.scss';
import plan1GigImageD from '../../images/plan-1gig-d.jpg';
import plan2GigImageD from '../../images/plan-2gig-d.jpg';
import plan5GigImageD from '../../images/plan-5gig-d.jpg';
import plan1GigImageHero from '../../images/plan-1gig-hero.jpg';
import plan2GigImageHero from '../../images/plan-2gig-hero.jpg';
import plan5GigImageHero from '../../images/plan-5gig-hero.jpg';
import { ROUTES } from '../../lib/constants';
import { Button } from '../Button/Button';
import { PlanType } from '../../lib/types';
import { Image } from '../Image/Image';

const PLAN_HERO_DATA: Record<PlanType, {
  image: string;
  imageHero: string;
  imageDesc: string;
}> = {
  '1 Gig': {
    image: plan1GigImageD,
    imageHero: plan1GigImageHero,
    imageDesc: 'Mother with small child looking at laptop.',
  },
  '2 Gigs': {
    image: plan2GigImageD,
    imageHero: plan2GigImageHero,
    imageDesc: 'Man with headphones looking at laptop while puppy is standing on desk.',
  },
  '5 Gigs': {
    image: plan5GigImageD,
    imageHero: plan5GigImageHero,
    imageDesc: 'Senior couple sitting by swimmimg pool. Man looking at laptop. Woman looking at phone.',
  },
};

export const PlanHero = (props: {
  type: PlanType,
  children?: ReactNode;

}): React.JSX.Element => {
  const { image, imageHero, imageDesc } = PLAN_HERO_DATA[props.type];

  return (
    <section className={`${styles.hero} ${styles['hero__' +props.type.replace(' ', '').toLowerCase()]}`}>
      <div className={styles.waves}>
        <div className={styles.designElement}></div>
      </div>

      <div className={`grid-12 ${styles.container}`}>
        <div className={styles.card}>
          <div className={styles.header}>
            <h1 className='headline__h2'>
              { props.type === '1 Gig' && 'Connect & Control' }
              { props.type === '2 Gigs' && 'Work Hard, Play Hard' }
              { props.type === '5 Gigs' && 'Everything & Everywhere' }
            </h1>

            <div className={styles.imageWrap}>
              <Image
                sources={[
                  { src: image, breakpoint: 'default'},
                  { src: imageHero, breakpoint: '960px'}
                ]}
                alt={imageDesc}
                loading="eager"
              />
            </div>

          </div>

          <div>
            <div className={styles.priceWrap}>
              <p className='headline__h2'>
                { props.type }
              </p>
              <p className='headline__h2'> 
                { props.type === '1 Gig' && '$80' }
                { props.type === '2 Gigs' && '$95' }
                { props.type === '5 Gigs' && '$150' }
                <span> / month</span>
              </p>
            </div>

            <div className={styles.body}>
              { props.children }
            </div>

            <div className={styles.footer}>
              <Button
                className={styles.packageBtn}
                path={ROUTES.checkAvailability.path}  
                target='_self'
                size='lg'
                gradient={ props.type === '2 Gigs' ? 'orange' : undefined }
    
              >
                Select Package
              </Button>
              
              <Button 
                className={styles.compareBtn}
                seconday={true}
                path={ROUTES.gigInternet.path}
                target='_self'
                size='lg'
              >
                Compare Packages
              </Button>
            </div>

          </div>
        </div>
      </div>
    </section>
  )

}